module.exports = __webpack_public_path__ + "img/prize-01.63443440.png";